import React, { useContext } from "react";
import {
  Card,
  CardContainer,
  CardSubtitle,
  CardTitle,
  CardWrapper,
} from "../Blog/BlogCardElements";
import { BackgroundImageWithShadow } from "../BackgroundImage";
import { BtnWrapBlog } from "../InfoSection/InfoElements";
import { Button } from "../ButtonElement";
import { LanguageContext } from "../LanguageContext";

const ProjectCardSection = (props) => {
  const [language] = useContext(LanguageContext);
  const buttonLabel =
    language[0].eng === "true" ? "Learn More" : "További részletek";

  return (
    <CardContainer>
      <CardWrapper>
        {props.image && (
          <BackgroundImageWithShadow backgroundImage={props.image}></BackgroundImageWithShadow>
        )}
        <Card>
          <CardTitle>{props.title}</CardTitle>
          <CardSubtitle>{props.description}</CardSubtitle>
          <BtnWrapBlog style={{ padding: "20px" }}>
            <Button
              to={props.link}
              smooth="true"
              duration={500}
              spy="true"
              offset={-80}
              primary={0}
              dark={0}
            >
              {buttonLabel}
            </Button>
          </BtnWrapBlog>
        </Card>
      </CardWrapper>
    </CardContainer>
  );
};

export default ProjectCardSection;
